export default __webpack_public_path__ + "static/analytics-snapshot-70b9f8c66bf2cc5cb0979f94a8e1782c.jpg";